import styled from 'styled-components';
import { Typ31 } from 'dc/Typ';
import Lab010 from 'dc/Lab010';

export const Wrapper = styled.div`
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-end;
  padding: 0 16px;
`;

export const Column = styled.div`
  width: 33.3333%;
  max-width: 140px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
`;

type StandProps = {
  colors: string[];
};

export const SmallStand = styled.div<StandProps>`
  height: 44px;
  width: 100%;
  border-top-right-radius: 8px;
  background: ${props =>
    `linear-gradient(174.49deg, ${props.colors[0]} 4.4%, ${props.colors[1]} 174.38%);`};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-weight: bold;
  font-size: 24px;
  line-height: 120%;
`;

export const MediumStand = styled.div<StandProps>`
  height: 67px;
  width: 100%;
  border-top-left-radius: 8px;
  background: ${props =>
    `linear-gradient(184.95deg, ${props.colors[0]} 3.99%, ${props.colors[1]} 150.96%);`};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-weight: bold;
  font-size: 32px;
  line-height: 120%;
`;

export const LargeStand = styled.div<StandProps>`
  height: 103px;
  width: 100%;
  border-radius: 8px 8px 0 0;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  background: ${props =>
    `linear-gradient(178.98deg, ${props.colors[0]} 4.72%, ${props.colors[1]} 99.12%);`};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-weight: bold;
  font-size: 60px;
  line-height: 120%;
`;

export const Avatar = styled.div`
  width: 72px;
  height: 72px;
  background: black;
  border-radius: 50%;
  margin-bottom: 8px;
`;

export const Name = styled(Typ31)`
  max-width: 120px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-bottom: 4px;
`;

export const Label = styled(Lab010)`
  margin-bottom: 16px;
  span {
    color: #263238;
    font-weight: bold;
  }
`;
